export default __webpack_public_path__ + "static/media/fb.f0391d69.svg";